import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RadioSharedModule } from '../../atoms/radio/radio.module';
import { SearchFiltersSharedComponent } from './search.filters.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { InputCalendarSharedModule } from '../../organisms/input.calendar/input.calendar.module';

@NgModule({
    declarations: [
        SearchFiltersSharedComponent
    ],
    imports: [
        FormsModule,
        CommonModule,
        RadioSharedModule,
        ReactiveFormsModule,
        IconSharedModule,
        InputCalendarSharedModule
    ],
    exports: [
        SearchFiltersSharedComponent
    ]
})

export class SearchFiltersSharedModule {}
